import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../../../services/auth.services'
import { RestServices } from '../../../../services/rest.services'
import { SharedServices } from '../../../../services/shared.services'
import { ordinalSuffixOf } from '../../../../../helper/common'
import { MailService } from '@app/services/mail.service'
import { PagingModel } from '@models/commons/paging.model'
import { AppUtilService } from '@app/shared/utils/app-util.service'
import { HttpErrorResponse } from '@angular/common/http'
import { STATUS_CODE } from '@app/shared/constants/app.const'
import { ResponseModel } from '@app/shared/models/commons/response.model'
import { PagingResultModel } from '@app/shared/models/commons/paging-result.model'

@Component({
    selector: 'app-mail-history',
    templateUrl: './mail-history.component.html',
    styleUrls: [
        '../../../../stagingcss/main-body.component.css',
        './mail-history.component.css',
        '../../../../stagingcss/lui-select.component.css',
        '../../../top/top.component.css'],
})
export class MailHistoryComponent implements OnInit {
    listClientMail: any = []
    hiddenModal = 'hidden'
    en = {}
    showEN = true
    IGNORE = ['broadcast']

    total: number = 0
    paging: PagingModel = {
        pageIndex: 0,
        pageSize: 30,
        sortColumn: 'sendTime',
        sortType: -1
    }

    constructor(
        private authData: AuthService,
        private restApi: RestServices,
        private _sharedService: SharedServices,
        private mailService: MailService,
        private appUtilService: AppUtilService
        ) {
    }

    ngOnInit() {
        this.loadMailHistoryData()
        $('ons-page').find('.ng-scrollbar').addClass('-vertical')
    }

    loadMailHistoryData(): void {
        this.authData.authToken().then(tokenReNew => {
            this.mailService.mailHistory(this.paging, tokenReNew).subscribe((res: ResponseModel<PagingResultModel<any>>) => {
                if (res.error_code === STATUS_CODE.SUCCESS) {
                    const _datasource = res.data.datasource || []
                    for (const mail of _datasource) {
                        if (mail.type === 'clientDevice' && mail.status === 'reserved') {
                            mail.type = ''
                        } else {
                            mail.type = 'mail-history-type-' + mail.type
                        }
                        if (mail.status === 'completed') {
                            mail.status = 'mail-history-status-completed'
                        } else if (mail.status === 'reserved') {
                            mail.status = 'mail-history-status-reserved'
                        } else if (mail.status === 'canceled') {
                            mail.status = 'mail-history-status-canceled'
                        }
                    }
                    this.listClientMail = this.listClientMail.concat(_datasource)
                    this.total = res.data.total || 0
                } else {
                    this.appUtilService.developerErrorHandle(res)
                }
            }, (errors: HttpErrorResponse) => {
                this.appUtilService.systemErrorHandle(errors)
            })
        }, (errors: HttpErrorResponse) => {
            this.appUtilService.systemErrorHandle(errors)
        })
    }

    onScroll() {
        if((this.total <= (this.paging.pageIndex + 1) * this.paging.pageSize)){
            return;
        }
        ++this.paging.pageIndex
        this.loadMailHistoryData()
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    selectPreview(clientMailDetail) {
        clientMailDetail['modal'] = 'MailHistory'
        this._sharedService.emitChange(clientMailDetail)
    }

    ordinalSuffixOf(i) {
        if (!i) {
            return ''
        }
        return ordinalSuffixOf(i)
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/status/mail-history/mail-history.component.ts